module.exports = __webpack_public_path__ + "static/media/refresh.cc091c00.svg";